import { useMemo, useState } from 'react'
import { Box, Slider, Stack } from '@mui/material'
import PropTypes from 'prop-types'

const ResolutionSlider = (props) => {
  const {
    defaultValue = 832,
    marks = [{ value: 480 }, { value: 960 }, { value: 1200 }],
    min = 320,
    max = 1440,
    shiftStep = 100,
    step = 1,
    sx = {},
    valueLabelDisplay = 'off',
    onChange,
    ...rest
  } = props

  const steps = useMemo(() => {
    return [min, ...marks.map(({ value }) => value), max]
  }, [marks, min, max])

  const [value, setValue] = useState(defaultValue)

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Slider
        defaultValue={defaultValue}
        marks={marks}
        max={max}
        min={min}
        shiftStep={shiftStep}
        step={step}
        sx={{ minWidth: 210, opacity: rest.disabled ? 0.5 : undefined, ...sx }}
        value={value}
        valueLabelDisplay={valueLabelDisplay}
        onChange={(event, newValue) => {
          const snapped = steps.find((step) => Math.abs(step - newValue) < 50)
          if (snapped) newValue = snapped
          setValue(newValue)
          onChange?.(newValue)
        }}
        {...rest}
      />
      <Box
        sx={{
          color: rest.disabled ? 'inactive.background' : 'inactive.text',
          userSelect: 'none',
          width: 54,
        }}
      >
        {value}
      </Box>
    </Stack>
  )
}

ResolutionSlider.propTypes = {
  defaultValue: PropTypes.number,
  marks: PropTypes.array,
  max: PropTypes.number,
  min: PropTypes.number,
  shiftStep: PropTypes.number,
  step: PropTypes.number,
  sx: PropTypes.object,
  valueLabelDisplay: PropTypes.oneOf(['auto', 'on', 'off']),
  onChange: PropTypes.func,
}

export default ResolutionSlider
